"use client";

import { useTranslations } from "next-intl";
import { Button, Heading } from "@pamperedchef/design-system";

export default function NotFound(): JSX.Element {
	const t = useTranslations("notFoundPage");

	return (
		<div className="text-center p-md">
			<Heading textContent={`404 | ${t("headline")}`} className="mb-lg" />
			<Button
				kind="primary"
				size="lg"
				onPress={() => {
					window.location.href = "/";
				}}
			>
				{t("goBackCta")}
			</Button>
		</div>
	);
}
